// Central place for the host / admin path.
// This URL is intentionally NOT linked from anywhere in the public UI.
// Only the host (Isaac) types it directly. Change the slug here at any time
// and everything (Login redirect, Navbar guards, App routing) follows.
//
// Real security still comes from the backend: every /api/admin/* endpoint
// requires role=admin + a valid session + TOTP (when enabled).
export const ADMIN_PATH = "/host-q9r4x8k2";
